import { useAuthentication } from 'gw-digital-auth-react';
import React, { useCallback, useContext, useState, useEffect } from 'react';
import _ from 'lodash';
import { LoadSaveService } from 'gw-capability-gateway-quoteandbind';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import { TranslatorContext } from '@jutro/locale';
import {ViewModelServiceContext} from 'gw-portals-viewmodel-react'
import { WizardPage, wizardProps } from 'gw-portals-wizard-react';
import { useValidation } from 'gw-portals-validation-react';
import { ClausesUtil } from 'gw-policycommon-util-js';
import metadata from './CommercialDetailsPage.metadata.json5';
import messages from './CommercialDetailsPage.messages';
import styles from './CommercialDetailsPage.module.scss';

function CommercialDetailsPackage(props) {
    const translator = useContext(TranslatorContext);
    const { wizardData: submissionVM, updateWizardData} = props;
    const viewModelService = useContext(ViewModelServiceContext);
    const [isPageInitialized, setPageInitialized] = useState(false);
    const { initialValidation, isComponentValid, onValidate, registerComponentValidation } = useValidation('CommercialDetailsPackage');
    const [isLoading, updateIsLoading] = useState(false);
    const [loadingClause, updateLoadingClause] = useState();
    const { authHeader } = useAuthentication();

    useEffect(() => {
        if(!isPageInitialized){
            setPageInitialized(true);
        }        
    }, [isPageInitialized, setPageInitialized]);



    const onNext = useCallback(async () => {
        submissionVM.value = await LoadSaveService.updateDraftSubmission(
            submissionVM.value,
            authHeader
        );
        return submissionVM;
    }, [submissionVM, authHeader]);

    const writeValue = useCallback(
        (value, path) => {
            _.set(submissionVM, path, value);
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );

    const getLoadingClause = useCallback((path, baseObject) => {
        const publicID = baseObject.coveragePublicID || baseObject.publicID;
        return publicID;
    }, [submissionVM]);

    const onUpdateCustomQuote = useCallback(
        () => {
            updateIsLoading(true);
            const lobCoverages = { 'businessOwners' : submissionVM.lobData.businessOwners.coverages.value};
            const quoteId = submissionVM.quoteID.value;
            const sessionUUID = submissionVM.sessionUUID.value;
            return LoadSaveService.updateCoverages(quoteId, sessionUUID, lobCoverages, authHeader)
            .then((updatedSubmission) => {
                submissionVM.lobData.businessOwners.coverages.value = updatedSubmission.businessOwners;
                updateIsLoading(false);
                updateWizardData(submissionVM);
                updateLoadingClause(undefined);
            });
        },
        [
            authHeader,
            submissionVM,
            updateWizardData,
            viewModelService,
            LoadSaveService
        ]
    );

    const onClauseChange = useCallback(
        (schedule, path) => {
            writeValue(schedule, path);
            return onUpdateCustomQuote();
        },
        [onUpdateCustomQuote, writeValue]
    );

    const changeSubmission = useCallback(
        (value, changedPath) => {
            _.set(submissionVM, changedPath, value);
            ClausesUtil.setClauseValue(submissionVM, value, changedPath);
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );

    const syncClauses = useCallback(
        async (value, changedPath) => {
            const basePath = ClausesUtil.getObjectPathFromChangedPath(changedPath);
            const baseObject = _.get(submissionVM, basePath);
            updateLoadingClause(getLoadingClause(basePath, baseObject));
            await onUpdateCustomQuote();
            updateWizardData(submissionVM);
        },
        [onClauseChange, submissionVM, updateWizardData, getLoadingClause, onUpdateCustomQuote]
    );

    const changeSubmissionAndSync = useCallback(
        (value, changedPath) => {
            changeSubmission(value, changedPath);
            syncClauses(value, changedPath);
        },
        [changeSubmission, syncClauses]
    );

    const overrideProps = {
        '@field': {
            labelPosition: 'left'
        },
        commercialCoverages:{
            loadingClause: loadingClause
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onSyncCoverages: syncClauses,
            onChangeSubmissionAndSync: changeSubmissionAndSync,
            onChangeClause: changeSubmission,
            onValidate: onValidate
            
        }
    };

    const skipInitialValidation = () => {
        const periodStatus = _.get(submissionVM.value, 'baseData.periodStatus');
        const quoted = periodStatus === 'Quoted';
        return quoted && submissionVM && submissionVM.aspects.valid && submissionVM.aspects.subtreeValid;
    }

    return (
        <WizardPage onNext={onNext} disableNext={!isComponentValid} skipWhen={skipInitialValidation}>
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                onValidationChange={onValidate}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={styles}
            />
        </WizardPage>
    );
}

CommercialDetailsPackage.propTypes = wizardProps;
export default CommercialDetailsPackage;
